<template>
	<pui-datatable v-if="!masterDetail" :modelName="model" :actions="actions" showFilterListBtn></pui-datatable>
	<pui-datatable
		v-else
		:modelName="model"
		:actions="actions"
		:externalFilter="externalFilter"
		:masterDetail="masterDetail"
		:parentModelName="parentModelName"
		:showCreateBtn="false"
		:showDeleteBtn="false"
		:isEditableRegistry="isEditableRegistry"
	></pui-datatable>
</template>

<script>
import PuiGridDetailMixin from 'pui9-mixins/PuiGridDetailMixin';
import HistoricoTermActions from './HistoricoTermActions';

export default {
	name: 'historicotermgrid',
	mixins: [PuiGridDetailMixin],
	data() {
		return {
			model: 'historicoterm',
			actions: HistoricoTermActions.gridactions
		};
	},
	created() {
		if (this.masterDetail) {
			const parentModel = this.$store.getters.getModelByName(this.parentModelName);
			const thisModel = this.$store.getters.getModelByName(this.model);
			if (parentModel && thisModel) {
				const parentModelPk = this.$puiUtils.getPathModelMethodPk(this.$router, this.parentModelName);
				thisModel.parentModelName = this.parentModelName;
				thisModel.parentModelPk = parentModelPk.pk;
			}
		}
	},
	methods: {
		isEditableRegistry() {
			return false;
		}
	}
};
</script>

<i18n>
{
    "en": {
		"grid.historicoterm.idhistorico":"Code",
		"grid.historicoterm.idencargo":"Order code",
		"grid.historicoterm.usralta":"Performer code",
		"grid.historicoterm.actor":"Performer",
		"grid.historicoterm.idestadoanterior":"Previous state code",
		"grid.historicoterm.estadoanterior":"Previous state",
		"grid.historicoterm.idestadonuevo":"New state code",
		"grid.historicoterm.estadonuevo":"New state",
		"grid.historicoterm.lang":"Language",
		"grid.historicoterm.idaccion":"Action code",
		"grid.historicoterm.accion":"Action",
		"grid.historicoterm.fecha":"Date",
		"grid.historicoterm.fechacreacion":"Date creació"
    },
    "es": {
		"grid.historicoterm.idhistorico":"Código",
		"grid.historicoterm.idencargo":"Código encargo",
		"grid.historicoterm.usralta":"Código actor",
		"grid.historicoterm.actor":"Actor",
		"grid.historicoterm.idestadoanterior":"Código estado anterior",
		"grid.historicoterm.estadoanterior":"Estado anterior",
		"grid.historicoterm.idestadonuevo":"Código estado nuevo",
		"grid.historicoterm.estadonuevo":"Estado nuevo",
		"grid.historicoterm.lang":"Idioma",
		"grid.historicoterm.idaccion":"Código acción",
		"grid.historicoterm.accion":"Acción",
		"grid.historicoterm.fecha":"Fecha",
		"grid.historicoterm.fechacreacion":"Fecha creación"
	},
    "ca": {
		"grid.historicoterm.idhistorico":"Codi",
		"grid.historicoterm.idencargo":"Codi encàrrec",
		"grid.historicoterm.usralta":"Codi actor",
		"grid.historicoterm.actor":"Actor",
		"grid.historicoterm.idestadoanterior":"Codi estat anterior",
		"grid.historicoterm.estadoanterior":"Estat anterior",
		"grid.historicoterm.idestadonuevo":"Codi estat nou",
		"grid.historicoterm.estadonuevo":"Estat nou",
		"grid.historicoterm.lang":"Idioma",
		"grid.historicoterm.idaccion":"Codi acció",
		"grid.historicoterm.accion":"Acció",
		"grid.historicoterm.fecha":"Data",
		"grid.historicoterm.fechacreacion":"Data creació"
	}
}
</i18n>
